<ng-container [ngTemplateOutlet]="isLoading ? spinner : mainContent"></ng-container>

<ng-template #mainContent>
  <h1 mat-dialog-title>Are you sure you want to remove this pilot activated lighting entry?</h1>
  <mat-dialog-actions>
    <button  id="deleteButton" class="mat-raised-button" (click)="delete()">
      Delete
    </button>
    <button class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
